import clsx from "clsx";
import * as React from "react";

interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: number;
}

const Sidebar = React.forwardRef<HTMLDivElement, SidebarProps>(
  ({ width = 300, children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        style={{ width }}
        className={clsx("ox-reset ox-SidebarRoot", className)}
      >
        {children}
      </div>
    );
  },
);
Sidebar.displayName = "Sidebar";
export { Sidebar };
export type { SidebarProps };
